const NATURAL_REQUIREMENTS = "requisitos-físicos";
const NATURAL_APPLICATION = "solicitud-física";
const LEGAL_REQUIREMENTS = "requisitos-morales";
const LEGAL_APPLICATION = "solicitud-moral";

const NUM_NATURAL_REQUIREMENTS = 0;
const NUM_NATURAL_APPLICATION = 1;
const NUM_LEGAL_REQUIREMENTS = 2;
const NUM_LEGAL_APPLICATION = 3;

const get = {
  [NUM_NATURAL_REQUIREMENTS]: NATURAL_REQUIREMENTS,
  [NUM_NATURAL_APPLICATION]: NATURAL_APPLICATION,
  [NUM_LEGAL_REQUIREMENTS]: LEGAL_REQUIREMENTS,
  [NUM_LEGAL_APPLICATION]: LEGAL_APPLICATION
};

export default {
  get,
  NUM_NATURAL_REQUIREMENTS,
  NATURAL_REQUIREMENTS,
  NUM_NATURAL_APPLICATION,
  NATURAL_APPLICATION,
  NUM_LEGAL_REQUIREMENTS,
  LEGAL_REQUIREMENTS,
  NUM_LEGAL_APPLICATION,
  LEGAL_APPLICATION
};
